export default __webpack_public_path__ + "static/media/ZingImage3x.5034631a.png";